import React from 'react'
import Error from 'next/error'
import Layout from './Layout'

export default class ErrorView extends React.Component {
	render() { 
		return <Layout><Error statusCode={404} /></Layout>
	}
}